import type { MBAPair } from "../../services/api";

type Props = {
  pairs: MBAPair[];
};

/** Pary MBA w języku szefa — bez technicznego żargonu („support 5%"), zamiast tego
 * pełne polskie zdania z konkretnymi liczbami. Lift ukryty (kolor wyróżnia silne pary).
 */
export default function MBATopPairs({ pairs }: Props) {
  if (pairs.length === 0) {
    return null;
  }
  return (
    <section className="card">
      <h2 className="card__title">🛒 Co kupowane razem</h2>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {pairs.map((p) => {
          const supportPct = (p.support * 100).toFixed(1);
          const confidencePct = Math.round(p.confidence * 100);
          const strong = p.lift >= 2.0;
          return (
            <li
              key={`${p.antecedent_sku}->${p.consequent_sku}`}
              style={{
                padding: "0.65rem 0",
                borderBottom: "1px solid var(--color-border, #e5e5e5)",
              }}
            >
              <div style={{ fontWeight: 600 }}>
                {p.antecedent_sku} + {p.consequent_sku}
                {strong && (
                  <span style={{ marginLeft: "0.5rem", color: "var(--color-accent, #c05621)" }}>
                    ⚡ silne powiązanie
                  </span>
                )}
              </div>
              <div style={{ fontSize: "0.92rem", opacity: 0.85, marginTop: "0.2rem" }}>
                Kupowane razem przez <strong>{supportPct}%</strong> klientów —{" "}
                <strong>{confidencePct}%</strong> kupujących {p.antecedent_sku} bierze też{" "}
                {p.consequent_sku}.
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
